import { Link, useRouterState } from '@tanstack/react-router'
import { HardDrive } from 'lucide-react'
import { constructionPages } from '@/features/under-construction/construction-pages'
import { PharmacyBrand } from './pharmacy-brand'
import { useUIStore } from './ui-store'

export function PharmacyNavigation({ pos = false }: { pos?: boolean }) {
  const inventoryActive = useRouterState({
    select: (state) => state.location.pathname === '/inventory',
  })
  const collapsed = useUIStore((state) =>
    pos ? state.posSidebarCollapsed : state.sidebarCollapsed,
  )
  return (
    <>
      <div className="pharmacy-sidebar-brand">
        <PharmacyBrand />
      </div>
      <nav className="pharmacy-navigation" aria-label="เมนูหลัก">
        <Link
          to="/"
          activeOptions={{ exact: true }}
          activeProps={{ className: 'active' }}
          title="Dashboard"
        >
          <span className="pharmacy-nav-icon">
            <img
              src={
                pos
                  ? '/assets/pos/dashboard.svg'
                  : '/assets/dashboard/dashboard.svg'
              }
              alt=""
            />
          </span>
          <span className="pharmacy-nav-label">Dashboard</span>
        </Link>
        <Link
          to="/pos"
          activeProps={{ className: 'active' }}
          title="POS / ขายหน้าร้าน"
        >
          <span className="pharmacy-nav-icon">
            <img
              src={pos ? '/assets/pos/pos.svg' : '/assets/dashboard/pos.svg'}
              alt=""
            />
          </span>
          <span className="pharmacy-nav-label">POS / ขายหน้าร้าน</span>
        </Link>
        <Link
          to="/inventory"
          activeProps={{ className: 'active' }}
          title="สินค้า"
        >
          <span className="pharmacy-nav-icon">
            <img
              src={
                inventoryActive
                  ? '/assets/inventory/products.svg'
                  : '/assets/dashboard/products.svg'
              }
              alt=""
            />
          </span>
          <span className="pharmacy-nav-label">สินค้า</span>
        </Link>
        {constructionPages
          .filter((item) => item.path !== '/receiving')
          .map((item) => (
            <Link
              key={item.icon}
              to={item.path}
              activeProps={{ className: 'active' }}
              title={item.label}
            >
              <span className="pharmacy-nav-icon">
                <img src={`/assets/dashboard/${item.icon}.svg`} alt="" />
              </span>
              <span className="pharmacy-nav-label">{item.label}</span>
            </Link>
          ))}
      </nav>
      <div className="pharmacy-sidebar-bottom">
        <Link
          to="/offline"
          className="pharmacy-device-link"
          title="ตรวจสอบอุปกรณ์"
          aria-label="ตรวจสอบอุปกรณ์"
        >
          <HardDrive size={18} />
          <span>ตรวจสอบอุปกรณ์</span>
        </Link>
        <button
          className="pharmacy-collapse"
          type="button"
          aria-label={collapsed ? 'ขยายแถบเมนู' : 'ย่อแถบเมนู'}
          aria-expanded={!collapsed}
          onClick={() => useUIStore.getState().toggleSidebar(pos)}
        >
          <img src="/assets/dashboard/collapse.svg" alt="" />
        </button>
      </div>
    </>
  )
}
